import { useNavigate, useSearchParams } from 'react-router-dom';

import { toast } from 'sonner';
import { z } from 'zod';

import { ERROR_WEAK_PASSWORD, meetsMinPasswordScore } from '../../../../shared/utils';
import { LOGIN } from '../../../shared/constants';
import { SUCCESS_MESSAGES } from '../constants';
import { resetPassword as apiResetPassword } from '../services/passwordService';
import useAuthForm from './useAuthForm';

const DEFAULT_VALUES = {
  password: '',
};

const formSchema = z.object({
  password: z
    .string()
    .min(1, 'Password is required.')
    .refine((value) => meetsMinPasswordScore({ password: value }), {
      message: ERROR_WEAK_PASSWORD,
    }),
});

const useResetPasswordForm = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const resetToken = searchParams.get('reset_password_token');

  const handleSubmit = async (formData) => {
    await apiResetPassword({
      password: formData.password,
      resetToken,
    });

    const { description, title } = SUCCESS_MESSAGES.password.update;
    toast.success(title, { description });

    navigate(LOGIN);
  };

  return useAuthForm({
    defaultValues: DEFAULT_VALUES,
    onSubmit: handleSubmit,
    schema: formSchema,
  });
};

export default useResetPasswordForm;
